import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const HighRiskBadge: FC = () => {
  const { t } = useTranslation(['component']);

  return (
    <Badge className="border-transparent bg-yellow-500 font-semibold text-foreground">
      {t('component:badge.highRisk')}
    </Badge>
  );
};
